import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      {/* Welcome Banner */}
      <div className="welcome-banner">
        <div className="welcome-container">
          <h1 className="welcome-title">
            Welcome to The Shapes United - Where Fashion Meets Inclusivity
          </h1>
        </div>
      </div>

      {/* Founder Section */}
      <div className="founder-section">
        <h2 className="founder-title">Our Founder's Story</h2>
        <div className="founder-content">
          <p className="founder-text">
            The Shapes United was born from a simple yet powerful observation: fashion should be accessible to everyone, regardless of physical ability. Our founder, a passionate advocate for inclusive design, noticed the gap in the market for stylish, functional clothing that considers the diverse needs of all individuals.
          </p>
          <p className="founder-text">
            With a background in both fashion design and occupational therapy, our founder combined technical expertise with creative vision to develop clothing that doesn't compromise on style while addressing practical needs. What started as a small collection for family and friends has grown into a movement celebrating diversity through design.
          </p>
          <p className="founder-text">
            Our mission is to empower individuals to express themselves confidently through clothing that understands their unique needs and celebrates their individuality.
          </p>
          <p className="founder-signature">– The Shapes United Team</p>
        </div>
      </div>

      {/* Philosophy Section */}
      <div className="philosophy-section">
        <h2 className="philosophy-title">Our Philosophy</h2>
        <div className="philosophy-content">
          <p className="philosophy-text">
            At The Shapes United, we believe that clothing should adapt to you, not the other way around. Every individual has their own unique shape, movement, and story, and our designs honor that diversity.
          </p>
          <p className="philosophy-text">
            We combine innovative adaptive features with contemporary fashion to create pieces that are not only functional but also make you feel confident and stylish. Our clothing is designed with attention to detail, from seamless construction to sensory-friendly fabrics, ensuring comfort without compromising on aesthetics.
          </p>
          <p className="philosophy-text">
            Sustainability is at the heart of our philosophy. We're committed to responsible production practices, using eco-friendly materials, and creating timeless pieces that last beyond seasons.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;